// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_zi1","cls2":"PodcastLibraryCarouselAd-cls2_xKE PodcastLibraryCarouselAd-cls1_zi1"};